module.exports = __webpack_public_path__ + "img/hash-02.46abe495.svg";